<script>
    import { Router, Route, Link } from 'svelte-routing';
</script>

<style>

/* Background video styles */
.video-background {
    position: relative;
    width: 100%;
    /* Remove height to let it adjust based on content */
    overflow: hidden;
    flex-shrink: 0;
}

/* Container for content to ensure it's above the video */
.about {
    z-index: 4;
    color: white;
    width: 70vh;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 6vh;
    background-color: rgba(0, 0, 0, 0.9); /* Halvgenomskinlig grå bakgrund */
    border-radius: 15px; /* Rundade hörn */
    padding: 40px; /* Inre marginal */
    transition: transform 0.6s ease, box-shadow 0.6s ease;
    font-family: 'MuseoModerna'
}

.about:hover {
    transform: scale(1.01);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);
}

.about-header {
    font-size: 2em;
    margin-bottom: 20px;
    position: relative;
}

.about-header::after {
    content: '';
    position: absolute;
    transform: translateX(-50%);
    bottom: -10px;
    left: 20%;
    width: 40%;
    height: 2px;
    background-color: #999; /* Linje mellan header och brödtext */
}

.header {
    padding-top: 50px;
    background-color: black;
    height: 100px;
    width: 100%;
    top: -5px;
    z-index: 4;
    position: relative;
}

.title {
    bottom: 18px;
}

.symbol {
    width: 350px;
}

.logo-link {
    text-decoration: none;
    color: inherit;
    display: block;
    z-index: 2;
}

.logo-link:hover {
    cursor: pointer;
}

.header:hover .block {
  animation: rotateBlocks 2.5s infinite linear;
}

footer {
    z-index: 2;
    position: fixed;
}

@keyframes rotateBlocks {
  0%   { transform: rotate(0deg); }
  20%  { transform: rotate(180deg); }  /* Fast rotation: 180deg in 20% of time */
  50%  { transform: rotate(225deg); }  /* Slow rotation: 45deg in 30% of time */
  70%  { transform: rotate(315deg); }  /* Fast rotation: 90deg in 20% of time */
  100% { transform: rotate(360deg); }  /* Slow rotation: 45deg in 30% of time */
}

.page-container {
    min-height: 100vh; /* Ensures the container covers the full viewport height */
    background-color: black; /* Fallback background color */
    width: 100%;
}

.video-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 700px; /* Covers the entire video container */
    z-index: 0; /* Places the video behind the content */
    object-fit: cover;
}

.video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 700px;
    background-color: rgba(0, 0, 0, 0.6); /* White with 80% opacity */
    z-index: 1; /* Ensure it is on top of the video */
    pointer-events: none; /* Allows clicks to pass through to elements below */
}

.about-contact-container {
    background-color: black;
    z-index: 100;
    min-height: 700px;
    color: white;
    width: 800px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    padding-top: 50px;
}

.index-number {
    color: #999;
    font-size: 2em;
}

.index-text {
    margin-left: 15px;
}

.about-section-title {
    font-family: 'MuseoModerna';
    font-size: 2em;
}

.divider {
    height: 2px; /* Thickness of the divider */
    background-color: #999; /* Color of the divider */
    margin: 15px auto; /* Spacing around the divider */
    border-radius: 5px; /* Optional: Adds rounded edges */
}

.linkedin-post {
    width: 100%;
    height: 400px; /* Adjust as needed */
    border: none; /* Remove default border */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add a shadow */
    border-radius: 8px; /* Rounded corners */
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.linkedin-post:hover {
    transform: translateY(-5px); /* Lift on hover */
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2); /* Deeper shadow on hover */
}

ul {
    list-style: none;
    padding: 10;
    margin: 0 auto;
  }

  .index-text {
    position: relative;
    text-decoration: none;
    color: inherit;
    display: inline-block;
    transition: color 0.3s ease;
}

/* Divider styles */
.index-text::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -5px; /* Adjusts the position of the divider below the text */
    width: 0; /* Initial width of the divider */
    height: 2px; /* Thickness of the divider */
    background-color: var(--hover); /* Color of the divider */
    transition: width 0.3s ease; /* Smooth transition for the divider growth */
}

/* Hover effect */
.index-text:hover::after {
    width: 100%; /* Grows to the full width of the text */
}

/* Optional: Change text color on hover */
.index-text:hover {
    color: var(--hover);
}

@media (max-width: 840px) {
    .about {
        width: 70%;
    }

    .about-contact-container {
        padding-left: 20px;
        padding-right: 20px;
        width: 90% !important;
    }

    .about-header::after {
        width: 80%;
        left: 40%;
}
}

</style>

<!-- Background Video -->


<!-- Content -->
<div class="page-container">
    <a href="/" class="logo-link">
        <div class="header">
            <div class="symbol">
                <!-- Your logo content -->
                <div class="line-vertical line-v1"></div>
                <div class="line-vertical line-v2"></div>
                <div class="line-horizontal line-h1"></div>
                <div class="line-horizontal line-h2"></div>
                <div class="block block-1"></div>
                <div class="block block-2"></div>
                <div class="block block-3"></div>
                <div class="block block-4"></div>
                <div class="title">boanalys<span class="tm">™</span></div>
            </div>
        </div>
    </a>
    <div class="video-container">
        <!-- Background Video -->
        <video autoplay muted loop playsinline class="video-background">
            <source src="/about.mp4" type="video/mp4" />
            Din video supporterar inte video.
        </video>
        <div class="video-overlay"></div>
        <div class="about">  
            <!-- About Text -->
            <div class="about-header">Innehåll</div>
            <br>
                <a href="#om-oss-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                    <span class="index-number">01</span>
                    <span style="margin-left: 15px;">om oss</span>
                </a>
            <br>
                <a href="#service-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                    <span class="index-number">02</span>
                    <span style="margin-left: 15px;">tjänsten</span>
                </a>
            <br>
                <a href="#nyheter-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                    <span class="index-number">03</span>
                    <span style="margin-left: 15px;">nyheter</span>
                </a>
            <br>
            <a href="#kontakt-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                <span class="index-number">04</span>
                <span style="margin-left: 15px;">kontakt</span>
            </a>
            <br>
            <div class="index-text" style="margin-left: 0px;">
                <Link to="legal" style="text-decoration: none; color: inherit;">
                    <span class="index-number">05</span>
                    <span style="margin-left: 15px;">allmänna villkor</span>
                </Link>
            </div>
            
        </div>
    </div>

    <div id="om-oss-section" class="about-contact-container" style="margin-top: 100px;">
        <div>
            <span class="about-section-title">Om Oss</span>
            <div class="divider"></div>
            <p>
                Välkommen till Boanalys! Vi är här för att förenkla hur du förstår och utvärderar bostadsrättsföreningar. 
                Genom att samla in och bearbeta data från flera källor erbjuder vi en plattform som gör komplex information 
                både tillgänglig och enkel att använda. Med vår <strong>AI-drivna</strong> teknologi presenteras allt i tydliga nyckeltal och insiktsfulla analyser.
              </p>
              <p>
                Vår moderna dashboard är designad med användaren i fokus. Här kan du enkelt navigera bland föreningens ekonomi, 
                underhållsplaner, energiförbrukning och stadgar. Med hjälp av vår chatbot, BoBot, får du svar på dina frågor i 
                realtid, vilket gör det smidigare än någonsin att fatta <strong>välgrundade</strong> beslut.
              </p>
              <p>
                Boanalys är en helt <strong>kostnadsfri</strong> tjänst som ständigt utvecklas. Oavsett om du är i Malmö, Göteborg, Stockholm 
                eller någon annan del av Sverige är vi här för att ge dig insikter som gör skillnad. Tack för att du använder Boanalys – vi ser fram emot att hjälpa dig!
              </p>        
        </div>
    </div>

    <div id="service-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Tjänsten</span>
            <div class="divider"></div>
            <p>
                Boanalys är ett kraftfullt verktyg som hjälper dig att få en tydlig översikt över bostadsrättsföreningar i hela Sverige. 
                Genom att samla in och bearbeta data från flera pålitliga källor erbjuder vi insikter om ekonomi, underhåll, energi och mycket mer, allt presenterat i en lättanvänd och modern plattform.
            </p>
            <p>
                Tjänsten använder sig av <strong>generativ AI</strong> för att sammanställa och analysera information. 
                Medan vi strävar efter högsta möjliga noggrannhet, är det viktigt att notera att vissa detaljer kan variera beroende på datakällornas kvalitet och komplexitet. 
                Informationen bör därför ses som en värdefull guide och kompletteras med egen undersökning vid behov.
            </p>
            <p>
                Vår ambition är att göra det enkelt för dig att fatta välgrundade beslut. 
                Boanalys är en hjälpande hand på vägen och vi hoppas att våra verktyg och insikter kan ge dig trygghet och klarhet i dina bostadsrättsfrågor. 
                Vi är här för att underlätta din process, samtidigt som vi uppmuntrar till att <strong>validera</strong> viktig information vid stora beslut.
            </p>
            <span class="about-section-title" style="font-size:1.2em;">Förening saknas</span>
            <p>
                Om din bostadsrättsförening inte finns med i Boanalys beror det på att vi saknar tillgång till föreningens årsredovisning. 
                För att lösa detta kan du skapa ett konto och manuellt ladda upp årsredovisningen för din förening.
            </p>
            <p>
                Du har möjlighet att ladda upp obegränsat med årsredovisningar, men vi rekommenderar att endast den senaste årsredovisningen laddas upp, 
                eftersom vi för närvarande inte erbjuder stöd för historisk analys. Dubbelkolla gärna att föreningen inte redan finns med i vår databas innan du laddar upp något.
            </p>
            <p>
                Analysen tar vanligtvis cirka 2 minuter, beroende på dokumentets komplexitet. När processen är klar kommer föreningens data att vara tillgänglig i vår databas för framtida användning.
            </p>
            <span class="about-section-title" style="font-size:1.2em;">Finansiering</span>
            <p>
                Om ni uppskattar vad vi gör och försöker åstadkomma så får ni gärna klicka in på vår Patreon. Alla donationer betyder mycket för oss och gör så att vi kan fortsätta 
                utveckla denna tjänst och även hålla den vid liv. 
            </p>
            <i class="fab fa-patreon"></i><a href="https://www.patreon.com/c/Boanalys" target="_blank" style="color: var(--hover);">&nbsp;Patreon</a>
        </div>
    </div>

    <div id="nyheter-section" class="about-contact-container" style="font-family: 'MuseoModerna';">
        <div>
            <span class="about-section-title">Nyheter</span>
            <div class="divider"></div>
            <p>2025-01-08</p>
            <iframe
                src="https://www.linkedin.com/embed/feed/update/urn:li:share:7282665655219240960" 
                class="linkedin-post"
                frameborder="0"
                allowfullscreen=""
                title="Inbäddat inlägg 3">
            </iframe>  
            <p>2024-12-10</p>
            <iframe
                src="https://www.linkedin.com/embed/feed/update/urn:li:share:7272159189471248452" 
                class="linkedin-post"
                frameborder="0"
                allowfullscreen=""
                title="Inbäddat inlägg 3">
            </iframe>  
            <p>2024-12-03</p>
            <iframe
                src="https://www.linkedin.com/embed/feed/update/urn:li:share:7269453445277831171"
                class="linkedin-post"
                frameborder="0"
                allowfullscreen=""
                title="Inbäddat inlägg 2">
            </iframe>  
            <p>2024-10-01</p>
            <iframe
                src="https://www.linkedin.com/embed/feed/update/urn:li:share:7248761225298276352"
                class="linkedin-post"
                frameborder="0"
                allowfullscreen=""
                title="Inbäddat inlägg 1">
            </iframe>        
        </div>
    </div>

    <div id="kontakt-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Kontakt</span>
            <div class="divider"></div>
            <p>
                För frågor eller samarbeten (press, partnerskap och annat), vänligen kontakta oss på <a href="mailto:info@boanalys.io" style="color: var(--hover);">info@boanalys.io</a>.
            </p>
            <p>
                Du hittar oss annars här:
            </p>
            <ul>
                <li>
                    <i class="fab fa-linkedin"></i> LinkedIn: <a href="https://www.linkedin.com/company/boanalys/" target="_blank" style="color: var(--hover);">linkedin.com/company/boanalys</a>
                </li>
                <li>
                    <i class="fab fa-patreon"></i> Patreon: <a href="https://www.patreon.com/c/Boanalys" target="_blank" style="color: var(--hover);">patreon.com/c/boanalys</a>
                </li>
                <li>
                    <i class="fa-brands fa-twitter"></i> X: <a href="https://x.com/boanalys40361" target="_blank" style="color: var(--hover);">x.com/c/boanalys40361</a>
                </li>
                <li>
                    <i class="fa-brands fa-facebook"></i> Facebook: <a href="https://www.facebook.com/people/Boanalys/61570346911684/" target="_blank" style="color: var(--hover);">facebook.com/people/boanalys/61570346911684/</a>
                </li>
            </ul>
        </div>
    </div>

    <div class="black-div"></div>

    <footer class="footer">
        <p>&copy; 2023 Boanalys. All rights reserved.</p>
        <p>Contact: <a href="mailto:info@boanalys.io">info@boanalys.io</a></p>
    </footer>
</div>
